const baseURL = "/v1/Setor";

const service = {
  methods: {
    $buscarOrigens(params) {
      return this.$api().get(`${baseURL}/Origens`, params);
    },
    $buscarSetores(params) {
      return this.$api().get(`${baseURL}`, params );
    },
    $visualizarSetor(id) {
      return this.$api().get(`${baseURL}/${id}`);
    },
    $cadastrarSetor(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarSetor(id, body) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarSetor(id) {
      return this.$api().patch(`${baseURL}/${id}/AlterarStatus`);
    },
    $excluirSetor(id) {
      return this.$api().delete(`${baseURL}/${id}`);
    },
    $detalharUsoSetor({ id, params}) {
      return this.$api().get(`${baseURL}/DetalharUso/${id}`, params);
    },
  },
};

export default service;